import base from "./flavors/base.js"
import simple from "./flavors/simple.js"
import extended from "./flavors/extended.js"
import clean from "./flavors/clean.js"
import comments from "./flavors/comments.js"
import contributions from "./flavors/contributions.js"
import fileDrop from "./extensions/file_drop.js"

const extendedFilesOnly = {
  ...extended,
  extensions: ["file_drop"], // Override to only handle files as attachments not as inline images
}

export const RichEditorHooks = {
  RichEditor_simple: Object.assign({}, base, simple),
  RichEditor_extended: Object.assign({}, base, extended),
  RichEditor_extended_without_inline: Object.assign(
    {},
    base,
    extendedFilesOnly,
    fileDrop,
  ),
  RichEditor_clean: Object.assign({}, base, clean),
  RichEditor_comments: Object.assign({}, base, comments),
  RichEditor_contributions: Object.assign({}, base, contributions),
}
